/**
 * Le Club — the pass deck.
 *
 * Owns which pass is out of the deck: hovering or focusing one lifts it clear
 * and pushes its neighbours aside, and the contact shadow slides opposite the
 * lean so the card reads as an object sitting above the page.
 *
 * The lean itself belongs to leclub-tilt.js, which writes --tilt-* on the
 * pass. Keeping the two apart lets the deck's motion stay slow and eased
 * while the lean tracks the pointer immediately.
 *
 * Pointer state only: the fan collapses to a snap carousel below 990px, so
 * touch users scroll through full-size passes instead.
 */
(function () {
  'use strict';

  function setup(deck) {
    if (deck.dataset.deckBound) return;
    deck.dataset.deckBound = 'true';

    var items = Array.prototype.slice.call(deck.querySelectorAll('[data-leclub-pass-item]'));
    if (!items.length) return;

    var active = -1;

    function activate(index) {
      if (index === active) return;
      active = index;
      deck.classList.toggle('has-active', index > -1);

      items.forEach(function (item, i) {
        var isActive = i === index;
        item.classList.toggle('is-active', isActive);

        if (index === -1 || isActive) {
          item.removeAttribute('data-push');
        } else {
          item.setAttribute('data-push', i < index ? '-1' : '1');
        }

        if (!isActive) item.style.removeProperty('--shadow-x');
      });
    }

    items.forEach(function (item, i) {
      var box = null;

      item.addEventListener('pointerenter', function () {
        box = item.getBoundingClientRect();
        activate(i);
      });

      item.addEventListener('pointermove', function (event) {
        if (!box || event.pointerType !== 'mouse') return;
        var px = (event.clientX - box.left) / box.width - 0.5;
        item.style.setProperty('--shadow-x', (-px * 26).toFixed(1) + 'px');
      });

      item.addEventListener('pointerleave', function () {
        box = null;
        if (active === i) activate(-1);
      });

      // Keyboard users get the same pop-out when the pass takes focus.
      item.addEventListener('focusin', function () {
        activate(i);
      });

      item.addEventListener('focusout', function (event) {
        if (item.contains(event.relatedTarget)) return;
        if (item.matches(':hover')) return;
        if (active === i) activate(-1);
      });
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-leclub-deck]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
